const gtranslateScriptUrl = 'https://cdn.gtranslate.net/widgets/latest/ln.js';

const defaultSettings = {
  default_language: 'en',
  native_language_names: true,
  languages: ['en', 'es', 'fr', 'zh-CN', 'tr', 'ru', 'ja', 'vi', 'pt'],
  wrapper_selector: '.gtranslate_wrapper',
  alt_flags: { en: 'usa', es: 'mexico', pt: 'brazil' },
};

let windowLoadPromise;
let widgetLoadPromise;

const waitForWindowLoad = () => {
  if (document.readyState === 'complete') {
    return Promise.resolve();
  }

  windowLoadPromise ??= new Promise((resolve) => {
    window.addEventListener('load', resolve, { once: true });
  });

  return windowLoadPromise;
};

const hasLanguageLinks = () => document.querySelector('.gtranslate_wrapper a[data-gt-lang]') !== null;

const loadWidget = () =>
  new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = gtranslateScriptUrl;
    script.dataset.iabbbGtranslateLoader = 'true';
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', resolve, { once: true });
    document.head.append(script);
  });

const ensureGTranslate = async () => {
  await waitForWindowLoad();

  if (hasLanguageLinks()) {
    return;
  }

  window.gtranslateSettings ??= defaultSettings;
  widgetLoadPromise ??= loadWidget();
  await widgetLoadPromise;
  widgetLoadPromise = undefined;
};

export default ensureGTranslate;
